import React, { FC } from 'react';
import { initSentry } from 'integrations/sentry/sentry';
import { FallBackErrorBoundary, SentryErrorBoundary } from 'integrations/sentry/elements';
import ResizeObserver from 'resize-observer-polyfill';
import { ThemeProvider } from 'styled-components';
import { utmostTheme } from '@utmost.co/utmost-design-system';
import { tokens } from '@beeline.com/bp-design-system';
import { CustomTenantModel } from 'providers/Tenant/Tenant.types';
import AppProviders from 'providers/AppProviders';
import 'react-grid-layout/css/styles.css';
import { WebsocketComponent } from '../websockets/WebsocketComponent';
import { OnIdle } from 'common/TimeoutDialog/OnIdle';
import { Route, Switch } from 'react-router-dom';
import { ExternalRoutes } from '@oc/pages/external/ExternalRoutes';
import App from 'common/App';
import { AuthUser } from 'src/providers/User/AuthUserModels';
import { SentrySamplingManager } from 'integrations/sentry/SentrySamplingManager';
import { DarklyFeature } from 'integrations/launchDarkly/legacy/DarklyFeature';
import { LaunchDarklyStringFeatureFlagKeys } from 'integrations/launchDarkly/legacy/stringFlags/types';

window.ResizeObserver = ResizeObserver;
const sentryClient = initSentry(false);

interface Props {
  tenant: CustomTenantModel | undefined;
  initialUser: AuthUser;
  messages?: Record<string, string>;
}

const EnterprisePage: FC<React.PropsWithChildren<Props>> = (props) => (
  // IMPORTANT: ThemeProvider needs to be the top level component to ensure that a theme is available for lower level components
  <ThemeProvider theme={{ ...utmostTheme, ...tokens }}>
    <AppProviders initialUser={props.initialUser} messages={props.messages} tenant={props.tenant}>
      <SentryErrorBoundary fallback={FallBackErrorBoundary} showDialog>
        <DarklyFeature flag={LaunchDarklyStringFeatureFlagKeys.sentrySamplingRateBpeWeb}>
          {({ value: sampling }) => <SentrySamplingManager sampling={sampling} client={sentryClient} />}
        </DarklyFeature>

        <WebsocketComponent />
        <OnIdle />
        <Switch>
          <Route path="/external" component={ExternalRoutes} />
          {props.initialUser && <Route path="/" render={() => <App sessionUser={props.initialUser} />} />}
        </Switch>
      </SentryErrorBoundary>
    </AppProviders>
  </ThemeProvider>
);

export default EnterprisePage;
